<template>
  <div class="menu_item" @click="movePage()">
    <img :src="`${image}?v=1`"
    >
    <span>{{ label }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    url: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  methods: {
    movePage() {
      if (this.label !== 'HOME'
        && this.currentUser.is_login === '0') {
        this.$store.dispatch('user/setShowLoginPage', true);
        return;
      }
      if (this.label === 'My Page') {
        this.$emit('handleClick', this.label);
        return;
      }
      if (this.url.startsWith('http')) {
        // window.open(this.url, '_blank').focus();
        window
          .open(this.url, '_self')
          .focus();
      } else {
        this.$router.push(this.url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.menu_item {
  display: flex;
  height: 60px;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  font-size: 12px;
  justify-content: space-around;
  cursor: pointer;
  @media screen and  (max-width: $tabletWidth) {
    height: 40px;
  }
  img {
    width: 36px;
    // height: 60px;
    @media screen and  (max-width: $tabletWidth) {
      width: 28px;
      // height: 38px;
    }
  }
  span {
    color: #6e6d6d;
    line-height: 8px;
    font-size: 14px;
    font-weight: bold;
    @media screen and  (max-width: $tabletWidth) {
      font-size: 12px;
    }
  }
}
</style>
